import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(2.000000, 1.000000)" fill="currentColor" fillRule="nonzero">
          <path d="M11.4545455,3.23076923 L8.72727273,3.23076923 L8.72727273,0.538461538 C8.72727273,0.241230769 8.48290909,0 8.18181818,0 L0.545454545,0 C0.244363636,0 0,0.241230769 0,0.538461538 L0,10.2307692 C0,10.528 0.244363636,10.7692308 0.545454545,10.7692308 L3.27272727,10.7692308 L3.27272727,13.4615385 C3.27272727,13.7587692 3.51709091,14 3.81818182,14 L11.4545455,14 C11.7556364,14 12,13.7587692 12,13.4615385 L12,3.76923077 C12,3.472 11.7556364,3.23076923 11.4545455,3.23076923 Z M3.27272727,3.76923077 L3.27272727,9.69230769 L1.09090909,9.69230769 L1.09090909,1.07692308 L7.63636364,1.07692308 L7.63636364,3.23076923 L3.81818182,3.23076923 C3.51709091,3.23076923 3.27272727,3.472 3.27272727,3.76923077 Z M10.9090909,12.9230769 L4.36363636,12.9230769 L4.36363636,4.30769231 L10.9090909,4.30769231 L10.9090909,12.9230769 Z" />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
